/*
 * Filter memory for /deals (board + table) and /quotes (table + board).
 *
 * Only URL-backed keys can be listed here. On both pages the search box, the
 * page number, "show all" and the column sort are component/hook state, not
 * the URL, so they are not listed. The column sort and funnels are still
 * remembered on the account by `useTableFilters` (table memory; owner
 * 2026-10-23), not by this rule. Never remembered: `new` (one-shot "open the create form" intent,
 * cleared when the form closes). /deals/:id and /quotes/:id get no rule:
 * `?create=quote|invoice` there is a one-shot convert command and must never
 * be restored.
 */
import type { FilterMemoryRule } from './types';

export const FILTER_MEMORY_DEALS_QUOTES: readonly FilterMemoryRule[] = [
  {
    path: '/deals',
    keep: [
      'view', // board (key absent, the default) vs `table`
      'stageId', // deal stage, single id
      'dealTypeId', // deal type, single id
      'leadSourceId', // lead source, single id
      'companyId', // company badge filter, single id
      'contactId', // contact badge filter, single id
      'projectId', // project badge filter, single id (table only; never sent to the board)
      'accountLeadId', // resolved account lead, single id (also seeded by the default-lead hook)
      'currency', // CHAR(3) currency code
      'closingDateAfter', // closing date lower bound, YYYY-MM-DD
      'closingDateBefore', // closing date upper bound, YYYY-MM-DD
    ],
  },
  {
    path: '/quotes',
    keep: [
      'view', // table (key absent, the default) vs `board`
      'stageId', // quote stage, single id
      'contactId', // contact badge filter, single id
      'companyId', // company badge filter, single id
      'dealId', // deal badge filter, single id
      'accountLeadId', // resolved account lead, single id (also seeded by the default-lead hook)
      'projectId', // header project filter, single id
      'lineProjectId', // projects on lines, CSV of ids
      'currency', // CHAR(3) currency code
      'validTillAfter', // expiry lower bound, YYYY-MM-DD (written by the expiry preset)
      'validTillBefore', // expiry upper bound, YYYY-MM-DD (written by the expiry preset)
      'issueDateAfter', // issue date lower bound, YYYY-MM-DD
      'issueDateBefore', // issue date upper bound, YYYY-MM-DD
    ],
  },
];
